import {Component, OnInit, NgZone} from '@angular/core';
import {ChangeDetectionStrategy} from '@angular/core';
import {FormGroup, Validators, FormControl} from '@angular/forms';
import {Router} from '@angular/router';

import {AppLoadingEventsEmitter} from 'src/app/modules/shared/events/loading.events';
import {AuthService} from 'src/app/modules/shared/services/auth.service';
import {UsersService} from 'src/app/modules/shared/services/users.service';
import {NotificationsService} from 'src/app/modules/shared/services/notification.service';
import {LocalisationService} from 'src/app/modules/shared/services/localisation.service';
import {HttpErrorResponse} from '@angular/common/http';
import {SocialService} from 'src/app/modules/shared/services/social.service';
import {getCookie} from '../../../shared/utilities/cookie.utilities';
import {Languages} from '../../../shared/enums/languages';

@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class LoginComponent implements OnInit {
    loginForm: FormGroup = new FormGroup({
        email: new FormControl('', [Validators.required, Validators.minLength(5), Validators.email]),
        password: new FormControl('', [Validators.required, Validators.minLength(5)])
    });
    persistLogin = false;
    languages = Object.keys(Languages).map(k => Languages[k]);

    constructor(
        private readonly router: Router,
        private readonly appIsLoadingEventsEmitter: AppLoadingEventsEmitter,
        private readonly authService: AuthService,
        private readonly usersService: UsersService,
        private readonly notificationService: NotificationsService,
        private readonly localisationService: LocalisationService,
        private readonly socialService: SocialService,
        private readonly ngZone: NgZone
    ) {
        // document.body.classList.remove('app-loading');
        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
    }

    ngOnInit() {

    }

    onLogin() {
        const email: string = this.loginForm.controls['email'].value;
        const password: string = this.loginForm.controls['password'].value;

        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

        this.authService.login(email, password).subscribe(({token}) => {
            this.authService.setJWT(token);

            this.usersService.getUserProfile()
                .subscribe(async () => {
                    await this.router.navigate(['dashboard']);

                    this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                });
        }, (err: HttpErrorResponse) => {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);

            if (err.status === 400) {
                this.notificationService.error(this.localisationService.localise('auth_invalid_credentials'));
            } else {
                this.notificationService.error(this.localisationService.localise('server_err_something_went_wrong'));
            }
        });
    }

    onFacebookLogin() {
        this.socialService.openFacebookLoginDialog().subscribe(({authResponse: {userID}}) => {
            this.appIsLoadingEventsEmitter.broadcastAppIsLoading(true);

            this.socialService.getFacebookInfo(userID)
                .subscribe(({email, first_name, last_name}) => {
                    this.authService.facebookLogin(
                        email,
                        first_name,
                        last_name,
                        userID,
                        this.localisationService.getLanguage(),
                        getCookie('referral')
                    )
                        .subscribe(() => {
                            this.usersService.getUserProfile()
                                .subscribe(() => {
                                    this.ngZone.run(async () => {
                                        await this.router.navigate(['dashboard']);

                                        this.appIsLoadingEventsEmitter.broadcastAppIsLoading(false);
                                    });
                                });
                        });
                });
        });
    }

    onLanguageSelected(locale: Languages) {
        let url = this.router.url;
        url = url.substr(0, (url.indexOf('?') !== -1 ? url.indexOf('?') : url.length));

        window.location.href = url + '?lang=' + locale.toLocaleLowerCase();
    }

    flagIcon(language: Languages): string {
        switch (language) {
            case Languages.English:
                return 'us';
            default:
                return language.toLowerCase();
        }
    }
}
